"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusMessage = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/text/semantics/text-block");
let StatusMessage = class StatusMessage extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.heading = '';
        this.message = '';
    }
    render() {
        return (0, lit_1.html) `
      <mm-text-block
        level="3"
        heading=${this.heading}
        description=${this.message}
        centered
      ></mm-text-block>
    `;
    }
};
StatusMessage.styles = (0, lit_1.css) `
    :host {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], StatusMessage.prototype, "heading", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], StatusMessage.prototype, "message", void 0);
StatusMessage = __decorate([
    (0, decorators_js_1.customElement)('mm-status-message')
], StatusMessage);
exports.StatusMessage = StatusMessage;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhdHVzLW1lc3NhZ2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzdGF0dXMtbWVzc2FnZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBMkM7QUFDM0MscURBQTJEO0FBQzNELHlEQUFzRDtBQUcvQyxJQUFNLGFBQWEsR0FBbkIsTUFBTSxhQUFjLFNBQVEsZ0JBQVU7SUFBdEM7O1FBU3VCLFlBQU8sR0FBRyxFQUFFLENBQUE7UUFDWixZQUFPLEdBQUcsRUFBRSxDQUFBO0lBWTFDLENBQUM7SUFWQyxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTs7O2tCQUdHLElBQUksQ0FBQyxPQUFPO3NCQUNSLElBQUksQ0FBQyxPQUFPOzs7S0FHN0IsQ0FBQTtJQUNILENBQUM7O0FBcEJNLG9CQUFNLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7R0FPbEIsQ0FBQTtBQUMyQjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7OENBQWE7QUFDWjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7OENBQWE7QUFWN0IsYUFBYTtJQUR6QixJQUFBLDZCQUFhLEVBQUMsbUJBQW1CLENBQUM7R0FDdEIsYUFBYSxDQXNCekI7QUF0Qlksc0NBQWEifQ==